import { ComponentConfig } from "@measured/puck";

import RichTextEditorField from "src/components/Puck/config/fields/RichTextEditorField";
import { HeroSection as HeroSectionComponent } from "./HeroSection";
import { HeroSectionWrapper } from "./components/HeroSectionWrapper";
import { HeroSectionProps } from "./types";

export type { HeroSectionProps } from "./types";

export const HeroSection: ComponentConfig<HeroSectionProps> = {
    label: "Hero Section",
    fields: {
        title: {
            type: "text",
            label: "Title",
        },
        subtitle: {
            type: "text",
            label: "Subtitle",
        },
        description: {
            type: "custom",
            label: "Description",
            render: (props) => <RichTextEditorField {...props} label="Description" />,
        },
        imageUrl: {
            type: "text",
            label: "Image URL",
        },
        ctaLabel: {
            type: "text",
            label: "CTA Button Label",
        },
        ctaLink: {
            type: "text",
            label: "CTA Button Link",
        },
    },
    defaultProps: {
        title: "Your Title Here",
        subtitle: "Optional subtitle",
        description: "Add your description here",
        imageUrl: "https://placehold.co/500x400",
        ctaLabel: "Learn More",
        ctaLink: "",
    },
    render: (props) => {
        return (
            <HeroSectionWrapper>
                <HeroSectionComponent {...props} />
            </HeroSectionWrapper>
        );
    },
};
